import React from "react";
import "../../styles/Dashboard.scss";
import { Modal } from "react-bootstrap";
import micro_reporter_api from "../../apis/micro-reporter-api";
import Utils from "../../libraries/utils";

const AddWidget = (props) => {
  const isActiveInput = (e, el) => {
    props.setisChangeWidgetItem(false);
    let user = JSON.parse(localStorage.getItem("user"));
    let value = {
      id: e.target.getAttribute("widget-item-id"),
      userId: user.id,
      type: e.target.getAttribute("widget-type"),
      active: e.target.checked,
    };
    try {
      (async () => {
        Utils.loadingScreen("show");
        let headers = {
          userId: user.id,
          username: user.username,
          relatedName: encodeURIComponent(user.username),
          relatedId: user.id,
        };
        const config = { headers };
        await micro_reporter_api
          .post("/micro-reporter/dashboard/save-or-delete", value, config)
          .then((response) => {
            let widgetItemId = response.data.type + "-" + response.data.id;
            document.querySelectorAll("#" + widgetItemId)[0].checked =
              response.data.active;
            props.setisChangeWidgetItem(true);
            Utils.loadingScreen("hide");
          });
      })();
    } catch (e) {
      Utils.loadingScreen("hide");
    }
  };

  function CreateList(props) {
    if (props.json) {
      return props.json.map((el, i) => {
        let uid = Math.random().toFixed(6) * 1000000 * (i + 1);
        return (
          <div key={i} style={{}}>
            <a
              className="switch-toggle"
              type="button"
              data-toggle="collapse"
              data-target={"#" + uid}
              style={{ width: "90%", display: "inline-block" }}
            >
              {props.type != "report" && props.type != "chart" ? (
                <span
                  className="project-title"
                  style={{ marginLeft: props.margin }}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> {el.name}{" "}
                </span>
              ) : props.type == "report" && el.reportCharts.length > 0 ? (
                <span
                  className="report-and-chart-title"
                  style={{ marginLeft: props.margin }}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> {el.name}{" "}
                </span>
              ) : props.type == "report" && el.reportCharts.length == 0 ? (
                <span
                  className="report-and-chart-title"
                  style={{ marginLeft: "25px" }}
                >
                  {el.name}{" "}
                </span>
              ) : (
                <label style={{ marginLeft: props.margin }}>{el.name}</label>
              )}
            </a>

            {props.type == "projects" ? null : (
              <label className="switch">
                <input
                  type="checkbox"
                  className="checkbox-input"
                  id={props.type + "-" + el.id}
                  checked={el.active}
                  widget-item-id={el.id}
                  widget-type={props.type}
                  onChange={(e) => isActiveInput(e)}
                />
                <span className="slider round"></span>
              </label>
            )}

            <div id={uid} className="collapse show">
              {el.reports && el.reports.length ? (
                <CreateList json={el.reports} margin={10} type={"report"} />
              ) : null}
            </div>
          </div>
        );
      });
    }
  }

  return (
    <div>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>Widgets</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <CreateList
              json={props.json.projects}
              margin={0}
              type={"projects"}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddWidget;
